/**
 * Imports for the Autodesk.Viewing.Math namespace
 */

/**
 * When exporting a THREE type here, make sure adequate JSDoc comments for the public
 * documentation exist both in three-slim.js and related three-backports.js.
 * @note v7 uses three.js for APS, three-slim.js for fluent. v8 is planned to use three-slim.js exclusively.
 */
export {
  Quaternion,
  //Euler,   // TODO: Add documentation before exporting
  Vector2,
  Vector4,
  Matrix3,
  Box2
  //Line3,   // Consider for export
} from "three";

export { LmvBox3 as Box3 } from "../wgs/scene/LmvBox3";
export { Vector3 } from "../wgs/scene/LmvVector3";
export { Matrix4 } from "../wgs/scene/LmvMatrix4";